import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCommodityCategories({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodityCategories, payload);
    const { data } = res;
    yield put(actions.fetchCommodityCategoriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityCategoriesFailure(err?.response?.data));
  }
}

export function* handleFetchTestCategories({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCategories, payload);
    const { data } = res;
    yield put(actions.fetchTestCategoriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTestCategoriesFailure(err?.response?.data));
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleAddTest({ payload }) {
  try {
    const res = yield call(API.addTest, payload.data);
    const { data } = res;
    yield put(actions.addTestSuccess(data));
    payload.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.addTestFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.addTestFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* addTestSaga() {
  yield takeLatest(
    actions.fetchCommodityCategories.type,
    handleFetchCommodityCategories
  );
  yield takeLatest(actions.fetchTestCategories.type, handleFetchTestCategories);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.addTest.type, handleAddTest);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
}
